// Import the functions you need from the SDKs you need
import { initializeApp, getApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: 'itwitter-v1.firebaseapp.com',
  projectId: 'itwitter-v1',
  storageBucket: 'itwitter-v1.appspot.com',
  messagingSenderId: '659187297161',
  appId: '1:659187297161:web:c6d449723cfec6dfe38f58',
};

// after done of this try .env variable for all

// Initialize Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const db = getFirestore();
const storage = getStorage();
export { app, db, storage };
